export { getUserDownloads, saveUserDownload }

const toolkitApiUrl = `${import.meta.env.VITE_TOOLKIT_URL}/api`

async function getUserDownloads(settings) {
  const params = new URLSearchParams(settings)
  const headers = new Headers({
    'Content-Type': 'application/json'
  })
  const response = await fetch(`${toolkitApiUrl}/collections?${params}`, {
    method: 'GET',
    headers,
    credentials: 'include'
  })
  const responseJSON = await response.json()
  if (response.status >= 200 && response.status < 300) {
    return responseJSON
  }
  throw {
    statusCode: response.status,
    responseJSON: responseJSON
  }
}

async function saveUserDownload(resource) {
  const headers = new Headers({
    'Content-Type': 'application/json'
  })
  const response = await fetch(`${toolkitApiUrl}/collections`, {
    body: JSON.stringify(resource),
    method: 'POST',
    headers,
    credentials: 'include'
  })
  const responseJSON = await response.json()
  if (response.status >= 200 && response.status < 300) {
    return responseJSON
  }
  throw {
    statusCode: response.status,
    responseJSON: responseJSON
  }
}
